import { useContext, useEffect } from 'react'
import { useCookies } from 'react-cookie'

import { AnalyticsContext, RecaptchaContext } from 'contexts'

type Props = {
  component: JSX.Element
  name?: string
}
export default function PageComponent(Props: Props) {
  const recaptcha = useContext(RecaptchaContext)
  const analytics = useContext(AnalyticsContext)
  const [cookies] = useCookies()

  useEffect(() => {
    if (Props.name && recaptcha.instance) {
      recaptcha.execute(Props.name)
    }
  }, [Props.name, recaptcha.instance])

  useEffect(() => {
    if (Props.name && analytics.instance) {
      analytics.setPageName(Props.name)
      analytics.sendPageLog(Props.name, {
        sa_trace: cookies.sa_trace,
        saDid: cookies.sa_did,
        saDid2: cookies.sa_did2,
        repo: 'account-web'
      })
    }
  }, [Props.name, analytics.instance])

  useEffect(() => {
    const handleSubmit = () => {
      analytics.sendEventLog(Props.name || '', `${Props.name}-submit`, {
        sa_trace: cookies.sa_trace
      })
    }

    const handleClick = (event) => {
      const clickedElement = event.target
      if (
        clickedElement.tagName === 'A' ||
        clickedElement.closest('a') ||
        clickedElement.tagName === 'BUTTON' ||
        clickedElement.closest('button')
      ) {
        const eventName = clickedElement.dataset.logId
          ? `${Props.name}:${clickedElement.dataset.logId}`
          : `${Props.name}:${clickedElement.innerText.toString().trim().replaceAll(' ', '-')}`
        analytics.sendEventLog(Props.name || '', eventName, {
          sa_trace: cookies.sa_trace,
          repo: 'account-web'
        })
      }
    }

    document.body.addEventListener('submit', handleSubmit)
    document.body.addEventListener('click', handleClick)
    return () => {
      document.body.removeEventListener('submit', handleSubmit)
      document.body.removeEventListener('click', handleClick)
    }
  }, [analytics.instance])

  return Props.component
}
